export default "__VITE_ASSET__BTegnmaA__"